import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { map, combineLatest, Subscription, distinctUntilChanged, Observable } from 'rxjs';
import { Logger, OrganizationService } from 'src/app/@shared';
import { CouponAsset } from '../../models/coupon-asset.model';
import { CouponAssetsService } from '../../services/coupon-assets.service';

const log = new Logger('CouponAssetsTableComponent');

@Component({
  selector: 'app-coupon-assets-table',
  templateUrl: './coupon-assets-table.component.html',
  styleUrls: ['./coupon-assets-table.component.scss']
})

export class CouponAssetsTableComponent implements OnInit {
  viewModel$ = combineLatest([
    this.couponAssetService.assets$,
    this.couponAssetService.isLoading$,
    this.couponAssetService.totalRecords$,
    this.couponAssetService.page$,
    this.organizationService.assetsUrl$,
  ]).pipe(
    map(([assets, isLoading, totalRecords, page, assetsUrl]) => {
      if (assets.length == 0 && page.pageIndex > 0) {
        page.previousPageIndex = 0
        page.pageIndex = 0
        this.couponAssetService.page(page);
        this.couponAssetService.reload();
      }
      return { assets, isLoading, totalRecords, page, assetsUrl }
    }),
  );
  assetsUrl$: Observable<string> = this.organizationService.assetsUrl$;
  flexMediaWatcher!: Subscription;
  displayedColumns = ['select','Image', 'AssetName', 'Type', 'FileName', 'ClientKey', 'Actions'];
  assetsList: CouponAsset[] = [];
  selection = new SelectionModel<CouponAsset>(true, []);

  constructor(private couponAssetService: CouponAssetsService<CouponAsset>,
    private route: ActivatedRoute,
    private router: Router,
    private mediaObserver: MediaObserver, private organizationService: OrganizationService) { }

  ngOnInit(): void {
    log.debug('init');

    this.couponAssetService.couponId = this.route.snapshot.params['couponId'];
    // detect changes in viewport size to handle show/hide of table columns
    const getAlias = (MediaChange: MediaChange[]) => {
      return MediaChange[0].mqAlias;
    };

    this.flexMediaWatcher = this.mediaObserver
      .asObservable()
      .pipe(
        distinctUntilChanged(
          (x: MediaChange[], y: MediaChange[]) => getAlias(x) === getAlias(y)
        ))
      .subscribe((change) => {
        if (change.some(x => x.mqAlias === 'xs')) {
          this.displayedColumns = ['select', 'AssetName'];
        }
        else {
          this.displayedColumns = ['select', 'Image', 'AssetName', 'Type', 'FileName', 'ClientKey', "Rank", 'Actions'];
        }
      });

    this.couponAssetService.assets$.subscribe((data) => {
      this.assetsList = data;
    });
  }


  onSort(sortState: Sort): void {
    this.couponAssetService.sort(sortState);
    this.selection.clear();
  }

  onPage(pageEvent: PageEvent): void {
    this.selection.clear();
    this.couponAssetService.page(pageEvent);
  }

  onRowDoubleClick(id: string) {
    this.router.navigate([`${id}/details`], { relativeTo: this.route });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.assetsList.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.assetsList.forEach(row => this.selection.select(row));
  }

  public getSelectedSectionRecords() {
    return this.selection.selected;
  }
  public clearSelection() {
    this.selection.clear();
  }
  public getImageSrc(assetsUrl: any, assets: any) {
    let imagesrc = '';
    if (assets.Type === 'application/pdf') {
      imagesrc = './assets/images/pdf.png';
    } else if (assets.Type.indexOf('audio') > -1) {
      imagesrc = './assets/images/mp3.jpg';
    } else if (assets.Type.indexOf('video') > -1) {
      imagesrc = './assets/images/mp4.png';
    } else if (assets.Type.indexOf('text') > -1) {
      imagesrc = './assets/images/text.png';
    }
    else {
      imagesrc = assetsUrl + '/' + assets.Detail.FileName;
    }
    return imagesrc;
  }
}
